export default {
  namespaced: true,
  state: {
    receptionFromDate: null,
    receptionToDate: null,
    samplingFromDate: null,
    samplingToDate: null,
    selectedSampleTypes: [],
    selectedStatuses: [],
    selectedFarms: [],
    selectedParcels: [],
    selectedAnalyseTypes: [],
    selectedProjects: [],
  },
  actions: {
    setReceptionFromDate({ commit }, value) {
      commit('setReceptionFromDate', value);
    },
    setReceptionToDate({ commit }, value) {
      commit('setReceptionToDate', value);
    },
    setSamplingFromDate({ commit }, value) {
      commit('setSamplingFromDate', value);
    },
    setSamplingToDate({ commit }, value) {
      commit('setSamplingToDate', value);
    },
    setSelectedSampleTypes({ commit }, value) {
      commit('setSelectedSampleTypes', value);
    },
    setSelectedStatuses({ commit }, value) {
      commit('setSelectedStatuses', value);
    },
    setSelectedFarms({ commit }, value) {
      commit('setSelectedFarms', value);
    },
    setSelectedParcels({ commit }, value) {
      commit('setSelectedParcels', value);
    },
    setSelectedAnalyseTypes({ commit }, value) {
      commit('setSelectedAnalyseTypes', value);
    },
    setSelectedProjects({ commit }, value) {
      commit('setSelectedProjects', value);
    },
    clearFilters({ commit }) {
      commit('clearFilters');
    },
  },
  mutations: {
    setReceptionFromDate(state, value) {
      state.receptionFromDate = value;
    },
    setReceptionToDate(state, value) {
      state.receptionToDate = value;
    },
    setSamplingFromDate(state, value) {
      state.samplingFromDate = value;
    },
    setSamplingToDate(state, value) {
      state.samplingToDate = value;
    },
    setSelectedSampleTypes(state, value) {
      state.selectedSampleTypes = value;
    },
    setSelectedStatuses(state, value) {
      state.selectedStatuses = value;
    },
    setSelectedFarms(state, value) {
      state.selectedFarms = value;
    },
    setSelectedParcels(state, value) {
      state.selectedParcels = value;
    },
    setSelectedAnalyseTypes(state, value) {
      state.selectedAnalyseTypes = value;
    },
    setSelectedProjects(state, value) {
      state.selectedProjects = value;
    },
    clearFilters(state) {
      state.receptionFromDate = null;
      state.receptionToDate = null;
      state.samplingFromDate = null;
      state.samplingToDate = null;
      state.selectedSampleTypes = [];
      state.selectedStatuses = [];
      state.selectedFarms = [];
      state.selectedParcels = [];
      state.selectedAnalyseTypes = [];
      state.selectedProjects = [];
    },
  },
};
